	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Resource.Buffer;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-fundamental/ref/Resource/Buffer.js
// module id = 22
// module chunks = 0